import * as LJS from "../../lib/littlejs.esm";
import { tilesize, tilesheets } from '../const/tiles.ts';
import Globals from '../globals.ts';
class LeftWall extends LJS.EngineObject {
    constructor(y) {
        let tileIndex = 137;
        let darkTile = LJS.tile(tileIndex, tilesize, tilesheets.DARK);
        // Forcce the x position
        let pos = LJS.vec2(0, y);
        super(pos, LJS.vec2(1, 1), darkTile);
        this.walkable = true;
        this.darkTile = darkTile;
        this.lightTile = LJS.tile(tileIndex, tilesize, tilesheets.LIGHT);
        this.setCollision(true, true, false, false);
        this.mass = 0; // Not affected by gravity
    }
    update() {
        // If the object is outside of the view we destroy it to free memory
        if (this.pos.y > Globals.depth + Globals.chunkSize) {
            this.destroy();
        }
        this.tileInfo = Globals.world == Globals.LIGHT ? this.lightTile : this.darkTile;
        super.update();
    }
}
export default LeftWall;
